import React, { Component } from 'react'
import { MOBILE_BREAKPOINT } from '../constants'

const getWidth = () => Math.min(document.documentElement.clientWidth, window.innerWidth || 0)
const getHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0)

const withWindowSize = WrappedComponent =>
  class extends Component {
    state = {
      width: getWidth(),
      height: getHeight(),
      innerWidth: window.innerWidth,
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleChange)
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleChange)
    }

    handleChange = () => {
      this.setState({
        width: getWidth(),
        height: getHeight(),
        innerWidth: window.innerWidth,
      })
    }

    render() {
      const { width, height, innerWidth } = this.state
      const isMobile = width < MOBILE_BREAKPOINT || height < 450

      return (
        <WrappedComponent
          windowWidth={width}
          windowHeight={height}
          innerWidth={innerWidth}
          isMobile={isMobile}
          {...this.props}
        />
      )
    }
  }

export default withWindowSize



// WEBPACK FOOTER //
// ./src/hoc/withWindowSize.js